/* Skinny Genie redesign: Wholesale page behaviour. Ported from
   wholesale-page-mockup.html: the three-way partner tab switcher, the sticky
   scroll-spy sub-nav, and the "New to Wholesale" carousel arrows. */

function showPartnerTab(key, btn){
  var tabs = btn.closest('.content-section').querySelectorAll('.partner-tab-btn');
  tabs.forEach(function(b){
    b.classList.remove('active');
    b.setAttribute('aria-selected', 'false');
  });
  btn.classList.add('active');
  btn.setAttribute('aria-selected', 'true');
  var panels = btn.closest('.content-section').querySelectorAll('.partner-grid.partner-tabbed .partner-card');
  panels.forEach(function(p){
    p.classList.toggle('active', p.getAttribute('data-partner-panel') === key);
  });
}

function scrollNtw(dir){
  var track = document.getElementById('ntw-track');
  if(!track) return;
  var card = track.querySelector('.ntw-card');
  var step = card ? card.getBoundingClientRect().width + 24 : 300;
  track.scrollBy({left: dir * step, behavior: 'smooth'});
}

function updateNtwArrows(){
  var track = document.getElementById('ntw-track');
  var prev = document.getElementById('ntw-prev');
  var next = document.getElementById('ntw-next');
  if(!track || !prev || !next) return;
  prev.classList.toggle('disabled', track.scrollLeft <= 4);
  next.classList.toggle('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
}

document.addEventListener('DOMContentLoaded', function(){
  var subnav = document.querySelector('.page-subnav');
  if(subnav){
    var links = Array.prototype.slice.call(subnav.querySelectorAll('.page-subnav-link'));
    var sections = links.map(function(link){
      return document.getElementById(link.getAttribute('href').slice(1));
    }).filter(Boolean);

    var setActive = function(id){
      links.forEach(function(link){
        link.classList.toggle('active', link.getAttribute('href') === '#' + id);
      });
    };

    if('IntersectionObserver' in window){
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            setActive(entry.target.id);
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      sections.forEach(function(section){ observer.observe(section); });
    } else {
      window.addEventListener('scroll', function(){
        var scrollPos = window.scrollY + 120;
        var current = sections[0];
        sections.forEach(function(section){
          if(section.offsetTop <= scrollPos){ current = section; }
        });
        if(current){ setActive(current.id); }
      }, { passive: true });
    }

    links.forEach(function(link){
      link.addEventListener('click', function(e){
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if(target){
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.pageYOffset - (subnav.offsetHeight + 12);
          window.scrollTo({ top: top, behavior: 'smooth' });
          setActive(target.id);
        }
      });
    });
  }

  var track = document.getElementById('ntw-track');
  if(track){
    track.addEventListener('scroll', updateNtwArrows, { passive: true });
    window.addEventListener('resize', updateNtwArrows);
    updateNtwArrows();
  }
});
